module.exports = __webpack_public_path__ + "static/media/en.7e20445f.pdf";